<template lang="pug">
.d-contents
  portal(v-if="dialogId && context" :to="`${dialogId}.${$dialogs.slots.content}`")
    signature-account-setup(
      :context="context"
      :dialog-id="dialogId"
      :is-active="isActive"
    )
</template>

<script>
import SignatureAccountSetup from '../Forms/SignatureAccountSetup.vue';
import { signatureSetup, clearSignatureSetup } from '../../services/signatureSetup';
// TEMP_SIGNATURE_PREVIEW
import { isSignaturePreviewContext } from '../../services/signaturePreview';

export default {
  components: { SignatureAccountSetup },
  data: () => ({ dialogId: undefined, context: null, cancelled: false, closing: false }),
  computed: {
    pending() { return signatureSetup.context; },
    userId() {
      // TEMP_SIGNATURE_PREVIEW
      if (isSignaturePreviewContext(this.pending)) return this.pending.previewUser.id;
      return this.$user.isAuthenticated ? this.$user.data.id : null;
    },
  },
  watch: {
    pending: { handler: 'open', immediate: true },
    userId() {
      if (this.context && this.context.userId !== this.userId) this.cancel();
    },
    $route() { this.cancel(); },
  },
  beforeDestroy() { this.cancel(); },
  methods: {
    isActive() {
      if (!this.context || this.cancelled || this.closing || signatureSetup.context !== this.context || !this.$dialogs.has(this.dialogId)) return false;
      // TEMP_SIGNATURE_PREVIEW
      if (isSignaturePreviewContext(this.context)) {
        return this.context.previewUser.id === this.context.userId && this.context.previewUser.organizer.id === this.context.organizationId;
      }
      return this.$user.isAuthenticated &&
        this.$user.data.id === this.context.userId && this.$user.data.organizer?.id === this.context.organizationId;
    },
    open(context) {
      if (!context || context.userId !== this.userId || (this.dialogId && this.$dialogs.has(this.dialogId))) return;
      this.context = context;
      this.cancelled = false;
      this.closing = false;
      this.dialogId = this.$dialogs.portal({
        attrs: { title: 'Настройте вход в личный кабинет', 'max-width': 640 },
        listeners: { close: this.release, 'click:outside': this.release, 'before:close': () => { this.closing = true; } },
      });
    },
    cancel() {
      this.cancelled = true;
      clearSignatureSetup();
      if (this.dialogId) this.$dialogs.close(this.dialogId);
    },
    release() {
      if (signatureSetup.context === this.context) clearSignatureSetup();
      this.dialogId = undefined;
      this.context = null;
    },
  },
};
</script>
